import React from "react";
import "../App.css";

export default function PrivacyPolicyPage() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "5px", color: "#1f2937" }}>
        Kebijakan Privasi
      </h1>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "20px" }}>
        Terakhir diperbarui: 12 November 2025
      </p>

      <p style={paragraphStyle}>
        Di <strong>MySite</strong>, kami di bawah naungan <strong>PT. Karya Digital Indo </strong> 
         berkomitmen untuk menjaga privasi dan keamanan data Anda. Dokumen ini menjelaskan
        bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda
        saat menggunakan layanan <strong>pembuatan dan hosting landing page</strong> kami.
        Dengan menggunakan layanan MySite, Anda dianggap telah menyetujui ketentuan dalam
        kebijakan privasi ini.
      </p>

      <h2 style={sectionTitleStyle}>1. Informasi yang Kami Kumpulkan</h2>
      <p style={paragraphStyle}>
        Kami hanya mengumpulkan data yang diperlukan untuk mengidentifikasi pengguna dan
        menyediakan layanan dengan baik, termasuk:
      </p>
      <ul style={listStyle}>
        <li>Nama pengguna</li>
        <li>Alamat email</li>
        <li>Informasi mengenai landing page yang dibuat oleh pengguna (seperti judul, isi, dan konfigurasi halaman).</li>
      </ul>

      <p style={paragraphStyle}>
        Kami tidak mengumpulkan informasi sensitif tanpa persetujuan Anda, dan tidak meminta
        data pribadi di luar keperluan layanan MySite.
      </p>

      <h2 style={sectionTitleStyle}>2. Cara Kami Menggunakan Data Anda</h2>
      <p style={paragraphStyle}>
        Data yang kami kumpulkan digunakan untuk:
      </p>
      <ul style={listStyle}>
        <li>Mengelola akun dan proses autentikasi pengguna.</li>
        <li>Menyediakan, memelihara, dan meningkatkan layanan MySite.</li>
        <li>Mengirim pemberitahuan penting terkait akun atau layanan Anda.</li>
        <li>Menjamin keamanan sistem dan mencegah penyalahgunaan layanan.</li>
      </ul>

      <h2 style={sectionTitleStyle}>3. Keamanan Data</h2>
      <p style={paragraphStyle}>
        Kami menerapkan langkah-langkah keamanan teknis dan organisasi untuk melindungi
        data Anda dari akses tidak sah, perubahan, atau pengungkapan. Semua data
        dikirimkan melalui koneksi yang terenkripsi dan disimpan di server yang aman.
      </p>

      <h2 style={sectionTitleStyle}>4. Berbagi Data</h2>
      <p style={paragraphStyle}>
        Kami tidak menjual atau menyewakan data pribadi Anda kepada pihak mana pun.
        Data hanya dapat dibagikan apabila:
      </p>
      <ul style={listStyle}>
        <li>Diperlukan oleh hukum, peraturan, atau proses hukum yang berlaku.</li>
        <li>Diperlukan untuk memproses pembayaran melalui mitra pembayaran resmi kami.</li>
      </ul>

      <h2 style={sectionTitleStyle}>5. Hak Anda</h2>
      <p style={paragraphStyle}>
        Anda berhak untuk mengakses, memperbarui, atau menghapus informasi pribadi Anda.
        Permintaan dapat dikirim melalui email ke{" "}
        <strong>support@mysite.co.id</strong>.
      </p>

      <h2 style={sectionTitleStyle}>6. Perubahan Kebijakan Privasi</h2>
      <p style={paragraphStyle}>
        Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Setiap perubahan
        akan diumumkan di halaman ini. Dengan terus menggunakan layanan kami setelah adanya
        pembaruan, Anda menyetujui versi terbaru dari kebijakan ini.
      </p>

      <h2 style={sectionTitleStyle}>7. Hubungi Kami</h2>
      <p style={paragraphStyle}>
        Jika Anda memiliki pertanyaan terkait privasi atau perlindungan data, silakan
        hubungi kami melalui email di{" "}
        <strong>support@mysite.co.id</strong>.
      </p>
    </div>
  );
}

const paragraphStyle = {
  fontSize: "1rem",
  color: "#4b5563",
  marginBottom: "20px",
  lineHeight: "1.6",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  fontWeight: "600",
  marginBottom: "10px",
  color: "#1f2937",
};

const listStyle = {
  marginLeft: "20px",
  color: "#4b5563",
  fontSize: "1rem",
  lineHeight: "1.6",
  marginBottom: "20px",
};
